import React, { useState } from "react";
import {
  EditableTextField,
  EditableSelectField,
  RadioOptions,

} from "../../../../Global_Component/CustomInputComponent";
import { CustomFileUpload,CustomFileUploadLikeSelect } from "../../../../Global_Component/customFileUplodComponent";
import OPTIONS from "../../../../constant/Option";
import { Box, Grid, Typography,Button ,Divider,Checkbox,FormControlLabel} from "@mui/material";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";

const SupplierDeclaration = () => {
  const [noOfProduct, setNoOfProduct] = useState([
    "SL NO 1",
    "SL NO 2",
    "SL NO 3",
   
   
   
  ]);

  function addMoreProduct() {
    setNoOfProduct([...noOfProduct, `SL No ${noOfProduct.length + 1}`]);
  }

  return (
    <Box
      sx={{
        maxWidth: "100%",
        margin: "auto",
        padding: "10px",
      
        borderRadius: "8px",
        backgroundColor: "#fff",
        height: "auto",
       
      }}
    >
      <Typography
        variant="h6"
        sx={{ marginBottom: "20px", fontWeight: "500", color: "#333" }}
      >
        SupplierDeclaration (Certifcate Of analysis)
      </Typography>

      <Divider
      sx={{
        height: "3px", // Thickness of the line
        backgroundColor: "gray", // Color of the line
        borderRadius: "2px", // Optional for rounded edges
      }}
    />

      <Box
         sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "100%",
     
            padding:3,
            paddingRight:10,
        
            textAlign:"left",
            // Custom scrollbar styles
            "&::-webkit-scrollbar": {
              width: "6px", // Width of the scrollbar
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f1f1f1", // Track color
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888", // Thumb color
              borderRadius: "10px", // Optional rounded edges for the thumb
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555", // Thumb color on hover
            },
          }}
      >
               <Typography
        sx={{
          fontSize: "1rem", // Scaled down for the title
          fontWeight: "bold",
          marginBottom: "16px",
        }}
      >
        Supplier Declaration
      </Typography>

      <Typography
        sx={{
          fontSize: "0.875rem", // Scaled-down subtitle
          marginBottom: "16px",
        }}
      >
       Supplier Agreement 
      </Typography>

      <Divider
        sx={{
          height: "3px",
          backgroundColor: "gray",
          marginBottom: "16px",
        }}
      />

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        This Non-Disclosure Agreement (the "Agreement") is entered into as of
        [Date], by and between:
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        <strong>Disclosing Party:</strong> [Your Full Legal Name or Company Name] [Your Address] [City, State, ZIP Code] [Email Address] [Phone Number]
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        <strong>Receiving Party:</strong> [Recipient's Full Legal Name or Company Name] [Recipient's Address] [City, State, ZIP Code] [Recipient's Email Address] [Recipient's Phone Number]
      </Typography>

      <Divider
        sx={{
          height: "3px",
          backgroundColor: "gray",
          marginBottom: "16px",
        }}
      />

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        <strong>1. Definition of Confidential Information</strong> <br />
        For the purposes of this Agreement, "Confidential Information" shall
        include any non-public information, including but not limited to trade
        secrets, business plans, financial data, customer lists, and any
        proprietary information disclosed by the Disclosing Party to the
        Receiving Party.
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        <strong>2. Obligations of Receiving Party</strong> <br />
        The Receiving Party agrees to:
        <ul>
          <li>
            a. Keep the Confidential Information confidential and not disclose
            it to any third party without the prior written consent of the
            Disclosing Party.
          </li>
          <li>
            b. Use the Confidential Information solely for the purpose of
            [Specify Purpose] and not for any other purpose.
          </li>
          <li>
            c. Take all reasonable measures to protect the confidentiality of
            the Confidential Information and prevent unauthorized disclosure.
          </li>
        </ul>
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        <strong>3. Exclusions from Confidential Information</strong> <br />
        The obligations of confidentiality do not apply to information that:
        <ul>
          <li>a. Is or becomes publicly available through no fault of the Receiving Party.</li>
          <li>
            b. Is independently developed by the Receiving Party without
            reference to the Confidential Information.
          </li>
          <li>
            c. Is rightfully obtained by the Receiving Party from a third party
            without any obligation of confidentiality.
          </li>
        </ul>
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        <strong>4. Duration of Confidentiality Obligations</strong> <br />
        The Receiving Party's obligations of confidentiality shall continue for
        a period of [Specify Duration, e.g., two (2) years] from the date of
        disclosure of the Confidential Information.
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        <strong>5. Return or Destruction of Confidential Information</strong> <br />
        Upon the Disclosing Party's written request, or the termination of
        discussions between the parties, the Receiving Party shall promptly
        return or, at the Disclosing Party's option, destroy all copies of the
        Confidential Information.
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginBottom: "16px" }}>
        <strong>6. Governing Law and Jurisdiction</strong> <br />
        This Agreement shall be governed by and construed in accordance with
        the laws of [Your Jurisdiction]. Any disputes arising under or in
        connection with this Agreement shall be subject to the exclusive
        jurisdiction of the courts in [Your Jurisdiction].
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginTop: "24px" }}>
        IN WITNESS WHEREOF, the parties hereto have executed this Non-Disclosure Agreement as of the Effective Date.
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginTop: "16px" }}>
        <strong>Disclosing Party:</strong> [Your Full Legal Name or Company Name] <br />
        [Your Signature] [Date]
      </Typography>

      <Typography sx={{ fontSize: "0.875rem", marginTop: "16px" }}>
        <strong>Receiving Party:</strong> [Recipient's Full Legal Name or Company Name] <br />
        [Recipient's Signature] [Date]
      </Typography>


      </Box>

      <Grid
        xs={12}
        container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-stat",
          gap: 1,
          borderTop: "1px solid gray",
        }}
      >
        <Grid md={"10"}>
          <FormControlLabel
               control={
                 <Checkbox
                 //   checked={checked}
                 //   onChange={handleChange}
                   sx={{
                     color: "primary.main",
                     "&.Mui-checked": {
                       color: "primary.main",
                     },
                   }}
                 />
               }
               label="Accept Term & Condition"
             />
        </Grid>
        <Grid md={"12"} sx={{ display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          }}>
        <CustomSecondaryButton label={"Back"} sx={{ margin: 2 }} />
        <CustomSuccessButton label={"Next"} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SupplierDeclaration;
